export const EmployeeInvitation = (json: IEmployeeInvitation): IEmployeeInvitationModel => {
	const fromJSON = () => {
		const { role, created_at, created_by, expires_at, updated_at, ...rest } = json
		return {
			role: mapRoleToSelectOption(role),
			createdAt: created_at ? new Date(created_at) : null,
			createdBy: created_by,
			expiresAt: expires_at ? new Date(expires_at) : null,
			updatedAt: updated_at ? new Date(updated_at) : null,
			...rest,
		}
	}

	return { ...fromJSON() }
}

export const employeeInvitationToJSON = (obj: Partial<IEmployeeInvitationModel>): Partial<IEmployeeInvitation> => {
	const { role, ...rest } = obj
	return {
		role: role?.value ? role.value : null,
		...rest,
	}
}
